/**
 * Stable, transport-level API contract shared by the web app and the API.
 *
 * Error responses are intentionally opaque: they never carry provider messages,
 * stack traces or anything derived from an exception thrown inside the API.
 */
export const API_BASE_PATH = '/api/v1';
export const API_ERROR_CODES = [
    'VALIDATION_ERROR',
    'RATE_LIMITED',
    'MAIL_DELIVERY_FAILED',
    'NOT_FOUND',
    'INTERNAL_ERROR',
];
const isRecord = (value) => typeof value === 'object' && value !== null;
export function isApiErrorResponse(value) {
    if (!isRecord(value) || !isRecord(value.error)) {
        return false;
    }
    const { code, message } = value.error;
    return (typeof message === 'string' &&
        typeof code === 'string' &&
        API_ERROR_CODES.includes(code));
}
//# sourceMappingURL=api.js.map